module.exports = __webpack_public_path__ + "static/media/fe.15bb6b50.png";